import { useQuery } from '@tanstack/react-query'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

const сheckSensorDataValidation = ({ queryKey: [
    _key, // eslint-disable-line no-unused-vars
    {
        processId,
        stepId,
        loggerNumber,
        token,
    },
] }) => {
    return requestBusinessObjects({
        method: 'GET',
        url: `skycenter/processevidence/${processId}/processevidencestep/${stepId}/logger/${loggerNumber}/sensor-data-validation`,
        token,
    })
        .then((response) => {
            return response.data.isValid
        })
}

function useCheckSensorDataValidation({
    processId,
    stepId,
    loggerNumber,
    enabled,
}) {
    const token = useJWTToken()

    return useQuery({
        queryKey: [
            'checkSensorDataValidation',
            {
                processId,
                stepId,
                loggerNumber,
                token,
            },
        ],
        queryFn: сheckSensorDataValidation,
        enabled,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useCheckSensorDataValidation
